module.exports = __webpack_public_path__ + "img/HellerDieGlocken.b8d4e5c5.jpg";